import React from "react";
import { X, ChevronRight } from "lucide-react";

const getFileIconProps = (fileName) => {
  if (!fileName) return { bg: "bg-gray-400", label: "FILE" };
  const ext = fileName.split('.').pop().toLowerCase();
  if (ext === 'pdf') return { bg: "bg-[#E5252A]", label: "PDF" };
  if (ext === 'docx' || ext === 'doc') return { bg: "bg-[#2B579A]", label: "DOC" };
  if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') return { bg: "bg-[#217346]", label: "XLS" };
  return { bg: "bg-gray-400", label: "FILE" };
};

const QuestionnaireSourcesListModal = ({ isOpen, onClose, sources, onSelectSource }) => {
  if (!isOpen) return null;

  return (
    <>
      <style>{`@keyframes slideInRight { from { transform: translateX(100%); } to { transform: translateX(0); } }`}</style>
      <div className="fixed inset-0 z-[9998] flex justify-end font-outfit">
        <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity" onClick={onClose} />
        
        <div className="relative w-full max-w-[550px] h-full bg-white shadow-2xl flex flex-col" style={{ animation: 'slideInRight 0.3s forwards' }}>
          <div className="flex items-center justify-between px-6 py-3 border-b border-gray-100">
            <h2 className="text-[18px] font-medium text-[#18101C]">Referenced Sources ({sources?.length || 0})</h2>
            <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-full text-gray-500"><X className="w-5 h-5" /></button>
          </div>
          
          <div className="flex-1 overflow-y-auto p-6 space-y-2 custom-scrollbar bg-[#FCFCFC]">
            {sources && sources.length > 0 ? sources.map((source, idx) => {
              const fileProps = getFileIconProps(source.file_name);
              
              return (
                <div key={idx} onClick={() => onSelectSource(source)} className="p-3 border border-gray-200 rounded-[8px] hover:border-[#BB42AE] hover:shadow-sm transition-all cursor-pointer bg-white flex items-center justify-between group">
                  <div className="flex-1 min-w-0 pr-4">
                    <div className="flex items-center gap-2.5 mb-2">
                      <div className={`w-5 h-5 rounded-[4px] flex items-center justify-center text-[8px] font-bold text-white shrink-0 ${fileProps.bg}`}>{fileProps.label}</div>
                      <h4 className="text-[14px] font-medium text-[#18101C] truncate">{source.file_name || "Unknown Document"}</h4>
                      
                      {source.page_number && source.page_number !== "Unknown" && (
                        <><span className="text-gray-300">|</span><span className="text-[13px] text-gray-500 whitespace-nowrap">Page {source.page_number}</span></>
                      )}
                    </div>
                    <p className="text-[13px] text-gray-500 italic line-clamp-2 leading-relaxed ml-[30px]">"{source.source_chunk}"</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-[#BB42AE] shrink-0 transition-colors" />
                </div>
              );
            }) : <div className="text-center py-12 text-gray-500">No sources available.</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionnaireSourcesListModal;
